function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.398 5.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#009de6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.686 184.29h-.539v.216h.539a.324.324 0 0 0 .322-.323v-.666a.323.323 0 1 0-.215 0v.666c0 .06-.048.107-.107.107M75.147 184.936h1.077a.108.108 0 0 0 0-.215h-1.077zM75.145 187.473h.538c.06 0 .108.048.108.108v.506a.323.323 0 1 0 .215 0v-.506a.324.324 0 0 0-.323-.323h-.538zM76.92 186.228h-1.614v.215h1.614c.06 0 .108.048.108.108v.558a.323.323 0 1 0 .215 0v-.558a.324.324 0 0 0-.323-.323M77.838 185.474a.32.32 0 0 0-.303.216h-1.594v.215h1.594a.322.322 0 1 0 .303-.43",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-72.763 -182.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.807 186.766a.11.11 0 0 0-.107-.108h-1.077v.215H76.7c.06 0 .107-.048.107-.107M77.085 185.044v-.558a.323.323 0 1 0-.216 0v.558c0 .06-.048.107-.107.107h-.345v.216h.345a.324.324 0 0 0 .323-.323M72.844 183.66l2.268-.715a.1.1 0 0 1 .033-.005v1.111c-.813 0-1.475.774-1.475 1.627 0 .854.76 1.575 1.475 1.575v1.402a.1.1 0 0 1-.034-.005c-.819-.268-2.348-1.204-2.348-2.257v-2.62c0-.052.033-.098.081-.114z",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-72.763 -182.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.303 184.21a1.43 1.43 0 0 0-1.428 1.429c0 .787.64 1.428 1.428 1.428a1.43 1.43 0 0 0 1.43-1.428 1.43 1.43 0 0 0-1.43-1.43m.872 1-1.04 1.04a.13.13 0 0 1-.183 0l-.52-.52a.13.13 0 0 1 .184-.184l.428.428.947-.947a.13.13 0 0 1 .184.184",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-72.763 -182.89)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.c3f58f5af16a127c1e268e99b9860460.svg";
export { ForwardRef as ReactComponent };